module.exports = __webpack_public_path__ + "static/media/kath.d05fd71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/kath.png
// module id = 1163
// module chunks = 0